import Skeleton from 'react-loading-skeleton';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { SCREENS } from 'src/constants/screens';
import { USER_ROLES } from 'src/constants/user';
import { localeStore } from 'src/mobx/localesStore';
import { history } from 'src/services/history';
import { hasRole } from 'src/utils/helpers';
import { confirmDelete } from 'src/utils/modalConfirmations';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Text, { TEXT } from 'src/view/components/Text/Text';
import menuGroupEditStore from 'src/view/screens/MenuManagementScreen/screens/MenuGroupEditScreen/store/menuGroupEditStore';
import menuGroupsStore from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/store/menuGroupsStore';
import { IMenuGroup } from 'src/view/screens/MenuManagementScreen/screens/MenuGroupsScreen/types/menuGroups';
import './style.scss';

interface IProps {
  menuGroup?: IMenuGroup;
}

const MenuGroupsListRow = ({ menuGroup }: IProps): JSX.Element => {
  const onSelectMenuGroup = () => {
    if (!menuGroup) return;
    history.push(SCREENS.MENU_GROUPS_EDIT(menuGroup.id));
  };

  const onCopyMenuGroup = () => {
    if (!menuGroup) return;
    history.push(SCREENS.MENU_GROUPS_CREATE());
    menuGroupEditStore.copyMenuGroupDetailsForEditing(menuGroup.id);
  };

  const onDeleteMenuGroup = () => {
    confirmDelete({
      message: localeStore.t('confirm_deleting_text'),
      onConfirm: () => menuGroup && menuGroupsStore.deleteMenuGroup(menuGroup.id),
      redConfirmBtn: true,
    });
  };

  return (
    <div className="menu-groups-list-row d-flex full-width">
      <div className="d-flex flex-row align-items-center cursor-pointer w-40 pr-4" onClick={onSelectMenuGroup}>
        {menuGroup ? <Text type={TEXT.LIST_ROW} text={menuGroup.name} /> : <Skeleton width={150} height={19.2} />}
      </div>
      <div className="d-flex flex-row align-items-center w-30">
        {menuGroup ? <Text type={TEXT.LIST_ROW} text={menuGroup.categories_count} /> : <Skeleton width={40} height={19.2} />}
      </div>
      <div className="d-flex flex-row align-items-center w-15">
        {menuGroup ? <Text type={TEXT.LIST_ROW} text={menuGroup.items_count} /> : <Skeleton width={40} height={19.2} />}
      </div>
      <div className="d-flex flex-row align-items-center justify-content-end w-15">
        {menuGroup ? (
          <>
            <Icon
              name={Icons.Copy}
              size={22}
              disabled={menuGroupsStore.isLoading}
              className="menu-groups-list-row__btn menu-groups-list-row__btn-copy"
              disabledClassName="menu-groups-list-row__btn_disabled"
              onPress={onCopyMenuGroup}
            />
            {hasRole([USER_ROLES.RESTAURANT_MANAGER]) ? (
              <Icon
                name={Icons.Trash}
                size={24}
                disabled={menuGroupsStore.isLoading}
                className="menu-groups-list-row__btn menu-groups-list-row__btn-delete ml-4"
                disabledClassName="menu-groups-list-row__btn_disabled"
                onPress={onDeleteMenuGroup}
              />
            ) : null}
          </>
        ) : (
          <Skeleton width={80} height={24} />
        )}
      </div>
    </div>
  );
};

export default MenuGroupsListRow;
